import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { AuthCard } from '../../features/auth/components/AuthCard';
import { ForgotPasswordForm } from '../../features/auth/components/ForgotPasswordForm';
import { PublicLayout } from '../../layouts/PublicLayout';

export const Route = createFileRoute('/$lang/forgot-password')({ component: ForgotPasswordScreen });

function ForgotPasswordScreen(): React.ReactNode {
  const { lang } = Route.useParams();
  const { t } = useTranslation();

  return (
    <PublicLayout lang={lang}>
      <AuthCard
        title={t('auth.forgotPassword.title')}
        subtitle={t('auth.forgotPassword.subtitle')}
        footer={
          <Link to="/$lang/login" params={{ lang }} className="text-accent underline">
            {t('auth.forgotPassword.backToLogin')}
          </Link>
        }
      >
        <ForgotPasswordForm lang={lang} />
      </AuthCard>
    </PublicLayout>
  );
}
